import type { JSXChild, JSXProps } from 'engine/index';

type ButtonProps = {
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	mode?: 'primary' | 'secondary' | 'tertiary';
	href?: string;
} & JSXProps;

export function Button({ href, size, mode, ...props }: ButtonProps, ...children: JSXChild[]) {
	const ourSize = size ?? 'md';
	const ourMode = mode ?? 'primary';

	const sizes: Record<typeof ourSize, string> = {
		xs: 'gap-1 rounded-sm p-1 text-xs',
		sm: 'gap-1 rounded-md px-2 py-1.5 text-xs font-semibold',
		md: 'gap-2 rounded-md px-3 py-2 text-sm font-semibold',
		lg: 'gap-3 rounded-md px-4 py-3 font-semibold',
		xl: 'gap-4 rounded-lg px-5 py-4 text-lg font-bold',
	};

	const modes: Record<typeof ourMode, string> = {
		primary: 'shadow-sm bg-theme-600 text-white hover:bg-theme-500 dark:bg-theme-700 dark:text-theme-100',
		secondary:
			'shadow-sm text-gray-800 bg-gray-200 hover:bg-gray-300 border border-gray-300 dark:text-gray-200 dark:bg-gray-700 dark:hover:bg-gray-900 dark:border-gray-800',
		tertiary: 'text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-gray-900',
	};

	if (href) {
		return (
			<a
				{...props}
				href={href}
				class={`${sizes[ourSize]} ${modes[ourMode]} flex w-fit items-center justify-center leading-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-600 disabled:cursor-not-allowed disabled:opacity-70`}
			>
				{children}
			</a>
		);
	} else {
		return (
			<button
				{...props}
				class={
					(props.class ?? '') +
					` ${sizes[ourSize]} ${modes[ourMode]} flex w-fit items-center justify-center leading-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-600 disabled:cursor-not-allowed disabled:opacity-70`
				}
			>
				{children}
			</button>
		);
	}
}
